<div class="modals about-us" [class.modals-show]="isModalAboutUsShow">
  <a class="close-modal" (click)="closeModal()"></a>
  <h4>MasloTochka - це:</h4>
  <ul>
    <li>Сайт для B2B користувачів в сфері автобізнесу;</li>
    <li>100% ОРИГІНАЛЬНІСТЬ продукції;</li>
    <li>Доступ до найбільшого в Україні асортименту мастил, рідин, фільтрів та інш.</li>
    <li>Прямий доступ до складів імпортерів;</li>
    <li>Опрацювання замовлень 24/7;</li>
    <li>Найкращі ціни за рахунок відсутності торгових представників, менеджерів, функцію яких виконує
      сайт
    </li>
  </ul>
</div>

<div class="dark-layer" [class.modals-show]="isDarkBackground" (click)="closeModal()"></div>
